import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('serviceDateField');

    return {
        SERVICE_DATE_FIELD_LABEL: t('serviceDateFieldLabel'),
        SERVICE_DATE_IS_REQUIRED: t('serviceDateIsRequired')
    };
};

export default useTranslation;
